import { CreateLinkTo } from "shared/constants/linkTo";
import { getProjectHrefPrefix } from "./getProjectHrefPrefix"

const getTargetProps = (e: any) => {
    const target = e.target

    if (!target) {
        return { target: undefined, targetLink: undefined }
    }

    let currentElement = target;
    let foundLink = null;
    let depth = 0;
    const MAX_DEPTH = 10;

    while (currentElement && depth <= MAX_DEPTH) {
        if (currentElement.tagName === 'A' && currentElement.href) {
            foundLink = currentElement;
            break;
        }
        currentElement = currentElement.parentElement;
        depth++;
    }

    const targetLink = foundLink?.href;

    return {
        target: foundLink,
        targetLink
    };
}


export const navigationHandler = (e: any, navigationProps: any) => {
    const { project } = navigationProps || {}
    const { target, targetLink } = getTargetProps(e)

    if (!(project?.projectId || navigationProps?.projectId)) return
    const isProjectLink = targetLink?.includes('/project/')
    const isDesignerLink = navigationProps?.projectId
   
    const url = isDesignerLink
        ? navigationProps?.author?.accountId && `${getProjectHrefPrefix(navigationProps)}${CreateLinkTo.designer(navigationProps?.author?.accountId)}`
        : targetLink
    window.open(url, '_blank')
  }
  import { CreateLinkTo } from "shared/constants/linkTo";
import { getProjectHrefPrefix } from "./getProjectHrefPrefix"

const getTargetProps = (e: any) => {
    const target = e.target

    if (!target) {
        return { target: undefined, targetLink: undefined }
    }

    let currentElement = target;
    let foundLink = null;
    let depth = 0;
    const MAX_DEPTH = 10;

    while (currentElement && depth <= MAX_DEPTH) {
        if (currentElement.tagName === 'A' && currentElement.href) {
            foundLink = currentElement;
            break;
        }
        currentElement = currentElement.parentElement;
        depth++;
    }

    const targetLink = foundLink?.href;

    return {
        target: foundLink,
        targetLink
    };
}


export const navigationHandler = (e: any, navigationProps: any) => {
    const { project } = navigationProps || {}
    const { target, targetLink } = getTargetProps(e)

    if (!(project?.projectId || navigationProps?.projectId)) return
    const isProjectLink = targetLink?.includes('/project/')
    const isDesignerLink = navigationProps?.projectId
   
    const url = isDesignerLink
        ? navigationProps?.author?.accountId && `${getProjectHrefPrefix(navigationProps)}${CreateLinkTo.designer(navigationProps?.author?.accountId)}`
        : targetLink
    window.open(url, '_blank')
  }
  